var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26012_2294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7025 14.315C27.7025 13.3933 27.6208 12.5183 27.4808 11.6667L14.2975 11.6667V16.9283H21.8458C21.5075 18.655 20.5158 20.1133 19.0458 21.105V24.605H23.5492C26.1858 22.1667 27.7025 18.5733 27.7025 14.315Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2975 28C18.0775 28 21.2392 26.74 23.5492 24.605L19.0458 21.105C17.7858 21.945 16.1875 22.4583 14.2975 22.4583C10.6458 22.4583 7.55417 19.9967 6.44584 16.6717H1.8025L1.8025 20.2767C4.10084 24.85 8.82584 28 14.2975 28Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44584 16.6717C6.15417 15.8317 6.0025 14.9333 6.0025 14C6.0025 13.0667 6.16584 12.1683 6.44584 11.3283L6.44584 7.72333L1.8025 7.72333C0.845835 9.61333 0.297503 11.7367 0.297503 14C0.297503 16.2633 0.845835 18.3867 1.8025 20.2767L6.44584 16.6717Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2975 5.54167C16.3625 5.54167 18.2058 6.25334 19.6642 7.64167L23.6542 3.65167C21.2392 1.38833 18.0775 0 14.2975 0C8.82584 0 4.10084 3.15 1.8025 7.72334L6.44584 11.3283C7.55417 8.00334 10.6458 5.54167 14.2975 5.54167Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26012_2294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.b69477416773a9baff927c0691231478.svg";
export { ForwardRef as ReactComponent };